const ROUTE_CONFIG_CACHE_KEY = 'landing_route_config_cache'
const ROUTE_CONFIG_CACHE_AT_KEY = 'landing_route_config_cache_at'
const ROUTE_CONFIG_CACHE_TTL_MS = 5 * 60 * 1000

const API_HOSTS = [
  'https://zfbxcx.winihao.top'
]

function normalizePath(path) {
  const raw = String(path || '').trim()
  if (!raw) {
    return ''
  }
  const withSlash = raw.startsWith('/') ? raw : `/${raw}`
  return withSlash.length > 1 && withSlash.endsWith('/') ? withSlash.slice(0, -1) : withSlash
}

function normalizeHost(host) {
  return String(host || '').trim().toLowerCase().split(':')[0]
}

function readCachedRouteConfig() {
  try {
    const cachedAt = Number(localStorage.getItem(ROUTE_CONFIG_CACHE_AT_KEY) || 0)
    if (!cachedAt || Date.now() - cachedAt > ROUTE_CONFIG_CACHE_TTL_MS) {
      return null
    }
    const raw = localStorage.getItem(ROUTE_CONFIG_CACHE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

function writeCachedRouteConfig(config) {
  localStorage.setItem(ROUTE_CONFIG_CACHE_KEY, JSON.stringify(config))
  localStorage.setItem(ROUTE_CONFIG_CACHE_AT_KEY, String(Date.now()))
}

export function normalizeRouteConfig(raw) {
  const source = raw && raw.adEntryPath ? raw : null
  const data = source || {
    adEntryPath: '/act/zt260630',
    protectedDomains: ['zt260630.ejnjyc.cn', 'zt260630.ejnjyc.com'],
    allowedPaths: ['/act/zt260630', '/pay-success'],
    legacyRedirects: { '/act/zt260618': '/act/zt260630' }
  }
  const adEntryPath = normalizePath(data.adEntryPath)
  const protectedDomains = Array.isArray(data.protectedDomains)
    ? data.protectedDomains.map(normalizeHost).filter(Boolean)
    : []
  const allowedSet = new Set()
  if (adEntryPath) {
    allowedSet.add(adEntryPath)
  }
  if (Array.isArray(data.allowedPaths)) {
    data.allowedPaths.forEach((item) => {
      const path = normalizePath(item)
      if (path) {
        allowedSet.add(path)
      }
    })
  }
  allowedSet.add('/pay-success')

  const legacyRedirects = {}
  if (data.legacyRedirects && typeof data.legacyRedirects === 'object') {
    Object.keys(data.legacyRedirects).forEach((from) => {
      const source = normalizePath(from)
      const target = normalizePath(data.legacyRedirects[from])
      if (source && target) {
        legacyRedirects[source] = target
      }
    })
  }

  return {
    adEntryPath,
    protectedDomains,
    allowedPaths: Array.from(allowedSet),
    legacyRedirects
  }
}

export function getLandingRouteConfigSync() {
  return normalizeRouteConfig(readCachedRouteConfig())
}

/** 广告固定入口：无需填手机号（与巨量 noPhone 一致） */
export function isAdLandingNoPhoneEntry() {
  const config = getLandingRouteConfigSync()
  const path = normalizePath(window.location.pathname)
  const host = normalizeHost(window.location.host)
  if (config.adEntryPath && path === config.adEntryPath) {
    return true
  }
  return config.protectedDomains.includes(host) && !!config.adEntryPath
}

export async function fetchLandingRouteConfig() {
  const cached = readCachedRouteConfig()
  if (cached) {
    return normalizeRouteConfig(cached)
  }

  const paths = ['/api/common/landingRouteConfig', '/common/landingRouteConfig', '/api/common/oceanLandingDomains', '/common/oceanLandingDomains']
  for (const host of API_HOSTS) {
    for (const path of paths) {
      try {
        const resp = await fetch(`${host}${path}`, { method: 'GET' })
        const result = await resp.json()
        if (resp.ok && result && result.code === 200 && result.data) {
          writeCachedRouteConfig(result.data)
          return normalizeRouteConfig(result.data)
        }
      } catch (e) {
        // try next
      }
    }
  }
  return normalizeRouteConfig(null)
}

export function createRouteGuard(routeConfig) {
  function isProtectedDomain() {
    const host = normalizeHost(window.location.host)
    return routeConfig.protectedDomains.includes(host)
  }

  function isAllowedPath(path) {
    if (!isProtectedDomain()) {
      return true
    }
    return routeConfig.allowedPaths.includes(normalizePath(path))
  }

  const fallbackPath = () => (isProtectedDomain() ? '/blocked' : '/')

  return {
    isProtectedDomain,
    isAllowedPath,
    fallbackPath
  }
}

export function buildLandingRoutes(routeConfig, { ThirdPage, BlockedPage, RulePage, fallbackPath }) {
  const routes = []
  if (routeConfig.adEntryPath) {
    routes.push({ path: routeConfig.adEntryPath, name: 'adEntry', component: ThirdPage })
  }
  Object.keys(routeConfig.legacyRedirects).forEach((from) => {
    routes.push({ path: from, redirect: routeConfig.legacyRedirects[from] })
  })
  routes.push(
    { path: '/pay-success', name: 'paySuccess', component: ThirdPage },
    { path: '/rule-page', name: 'rulePage', component: RulePage },
    { path: '/blocked', name: 'blocked', component: BlockedPage },
    { path: '/', name: 'home', component: ThirdPage },
    { path: '/fontend', redirect: fallbackPath },
    { path: '/fontend/pay-success', redirect: '/pay-success' },
    { path: '/index4.html', redirect: fallbackPath },
    { path: '*', redirect: fallbackPath }
  )
  return routes
}
